import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactTableForm from "../../../components/Common/ReactTableForm";
// import { Link } from "react-router-dom";
// import classNames from "classnames";

const NotificationsTable = ({ data, isLoading, onTableChange }) => {
  const DEFAULT_STYLE = {
    minWidth: 110,
    textAlign: 'center'
  }
  /*
   * @param status: true | false | null
   * */

  const [columns, setColumns] = React.useState([
    {
      Header: "Campaign ID",
      accessor: "campaign_id",
      src: "campaign_id",
      style: {
        ...DEFAULT_STYLE,
      },
      // accessor: row => <Link to={`/offers/${row.id}?history=true`}>{row.id}</Link>
      // isSorted: true,
    },
    {
      Header: "Campaign name",
      accessor: "campaign_name",
      src: "campaign_name",
      style: {
        ...DEFAULT_STYLE,
      },
      // style: {
      //   ...this.styleNumbers,
      //   minWidth: 110,
      // },
      // accessor: row => <Link to={`/offers/${row.id}?history=true`}>{row.name}</Link>
      // isSorted: true,
    },
    {
      Header: "Platform",
      accessor: "platform",
      src: "platform",
      style: {
        ...DEFAULT_STYLE,
      },
    },
    {
      Header: "Advertiser ID",
      accessor: "advertiser_id",
      src: "advertiser_id",
      style: {
        ...DEFAULT_STYLE,
      },
    },
    {
      Header: "Create time",
      src: "create_time",
      style: {
        ...DEFAULT_STYLE,
      },
      // style: {
      //   ...this.styleNumbers,
      //   minWidth: 110,
      // },
      accessor: row => row.create_time,
      // isSorted: true,
    },
  ]);

  return (
    <NotificationsTableStyled>
      <ReactTableForm
        loading={isLoading}
        columns={columns}
        data={data}
        onTableChange={onTableChange}
        // firstIsSticky
      />
    </NotificationsTableStyled>
  );
};

NotificationsTable.propTypes = {
  data: PropTypes.any,
  isLoading: PropTypes.bool,
  onTableChange: PropTypes.func,
};

const NotificationsTableStyled = styled.div`
  .notification-item-status {
    width: 20px;
    height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    i {
      color: #fff;
    }
  }
`;

export default NotificationsTable;
